import { EDITABLE_FIELDS } from '@routes/sidebar/admin-center/___shared___/components/tables/constants.ts';
import { COMMON_FILTER_PARAMS } from '@routes/sidebar/admin-center/___shared___/constants.ts';
import type { ReferencesRaw } from '@routes/sidebar/admin-center/tenant-client/___pages___/configuration/___shared___/types.ts';

import { MY_LEARNING_COLUMN_TITLE, MY_LEARNING_DATA_INDEX } from './constants.ts';

export const MY_LEARNING_COLUMNS_VIEW: ReferencesRaw[] = [
    {
        title: MY_LEARNING_COLUMN_TITLE.PATHWAY,
        dataIndex: MY_LEARNING_DATA_INDEX.PATHWAY,
        editable: false,
        require: false,
        sorter: true,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '240px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.DATE,
        dataIndex: MY_LEARNING_DATA_INDEX.DATE,
        editable: false,
        require: false,
        sorter: true,
        showSorterTooltip: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '100px',
        align: 'left',
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.RANK,
        dataIndex: MY_LEARNING_DATA_INDEX.RANK,
        editable: false,
        require: false,
        sorter: true,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '110px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.LOCATION,
        dataIndex: MY_LEARNING_DATA_INDEX.LOCATION,
        editable: false,
        require: false,
        sorter: true,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '120px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.SCORE,
        dataIndex: MY_LEARNING_DATA_INDEX.SCORE,
        editable: false,
        require: false,
        sorter: true,
        showSorterTooltip: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '90px',
        align: 'center',
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.ATTEMPT,
        dataIndex: MY_LEARNING_DATA_INDEX.ATTEMPT,
        editable: false,
        require: false,
        sorter: true,
        showSorterTooltip: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '100px',
        align: 'center',
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.STATUS,
        dataIndex: MY_LEARNING_DATA_INDEX.STATUS,
        editable: false,
        require: false,
        sorter: true,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '110px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.METHOD,
        dataIndex: MY_LEARNING_DATA_INDEX.METHOD,
        editable: false,
        require: false,
        sorter: true,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '160px',
        align: 'left',
        ...COMMON_FILTER_PARAMS,
    },
    {
        title: MY_LEARNING_COLUMN_TITLE.CERTIFICATE,
        dataIndex: MY_LEARNING_DATA_INDEX.CERTIFICATE,
        editable: false,
        require: false,
        sorter: true,
        showSorterTooltip: false,
        type: EDITABLE_FIELDS.INPUT_TEXT,
        dataSource: null,
        width: '70px',
        align: 'center',
    },
];
